import React from "react";
import Banner from "../components/home/banner";
import CatCards from "../components/home/catCards";
import Partners from "../components/home/partners";
import { Row } from "antd";
import OverseasProducts from "../components/home/overseasProducts";
import AeroflexProducts from "../components/home/aeroflexProducts";
import HomeServices from "../components/home/homeServices";

const UserHomePage = () => {
  return (
    <>
      <Banner />
      <CatCards />
      <Row className="max-lg:hidden">
        <Partners />
      </Row>
      <OverseasProducts />
      <AeroflexProducts />
      <HomeServices />
    </>
  );
};

export default UserHomePage;
